export default [
  {
    code: 'assessments.index',
    name: 'assessments.index',
    meta: {
      title: 'Assessments',
      icon: 'mdi-flask',
      authenticatable: true,
      sort: 500,
      permission: 'users.index',
    }
  }
]
